import { createSlice } from '@reduxjs/toolkit';
        
export const sessionSlice = createSlice({
    name: 'ux',
    initialState: {
        viewIsDirty: false
    },
    reducers: {
        setViewIsDirty: (state, action) => {
            state.viewIsDirty = action.payload;
        }
    }
});

export const { 
    setViewIsDirty, 
} = sessionSlice.actions;

export const selectViewIsDirty = state => state.ux.viewIsDirty;

export default sessionSlice.reducer;